import { render, staticRenderFns } from "./TeamRequestListSkeleton.vue?vue&type=template&id=56364145&scoped=true"
import script from "./teamRequestListSkeleton.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestListSkeleton.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestListSkeleton.vue?vue&type=style&index=0&id=56364145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56364145",
  null
  
)

export default component.exports